<template>
  <section class="retail-report__section">
    <svg
      width="1269"
      height="664"
      viewBox="0 0 1269 664"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="retail-report__section__svg"
    >
      <rect
        x="-396"
        y="378.582"
        width="100%"
        height="1340.67"
        transform="rotate(-16.4024 -396 378.582)"
        fill="#202F46"
      />
    </svg>
    <div class="ds-container retail-report__hero">
      <div class="ds-grid retail-report__hero__wrapper">
        <div
          :class="
            image
              ? 'ds-grid__col ds-grid__col--12 ds-lg-grid__col--5 ds-md-grid__col--6 ds-md-padding-bottom-12 ds-padding-bottom-0 ds-display-flex ds-align-items-center'
              : 'ds-grid__col ds-grid__col--12 ds-md-grid__col--8 ds-md-grid__col--offset-2 ds-lg-grid__col--6 ds-md-padding-bottom-12 ds-lg-grid__col--offset-3 ds-text-align-center retail-report__wrapper'
          "
        >
          <div class="retail-report__hero__content">
            <DsEyebrow
              :text="eyebrow"
              :theme="theme"
              class="ds-align-items-center"
            />
            <div>
              <h1 class="ds-heading-xlarge ds-margin-top-24 ds-color-white">
                {{ title }}
              </h1>
              <slot name="description">
                <div
                  v-if="description"
                  class="ds-text-medium sm-only-padding ds-color-white ds-padding-top-12"
                >
                  {{ description }}
                </div>
              </slot>
              <div
                v-if="link"
                class="ds-buttons-wrapper ds-padding-top-24"
                :class="{ 'retail-report__hero__button': !image }"
              >
                <DsLink
                  v-if="link"
                  :open-in-new-window="link.openInNewWindow"
                  :nuxt="link.nuxt"
                  :url="link.url"
                  :content="link.title"
                  :tracking-data="{ 'component-name': 'Retail Report Hero', text: link.title, title: title }"
                  type="button"
                  color="green"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="image"
          class="retail-report__hero__image-div"
          :class="{
            'ds-grid__col ds-grid__col--12 ds-md-grid__col--6 ds-lg-grid__col--5 ds-lg-grid__col--offset-2 retail-report__hero__image-container':
              image
          }"
        >
          <DsImageElement
            :image="image"
            :screen="screen"
            class="retail-report__hero__image"
            data-j-image
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { DsLink, DsEyebrow, DsImageElement } from 'awds'

const { theme } = useTheme()
const { screen } = useScreen()

defineProps({
  eyebrow: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    required: true
  },
  text: {
    type: String,
    default: ''
  },
  link: {
    type: Object,
    default: null
  },
  image: {
    type: Object,
    default: null
  },
  description: {
    type: String,
    default: ''
  }
})
</script>
<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';
@import 'awds/foundation-mixins.scss';

.retail-report {
  &__hero {
    min-height: $spacing-192;
    z-index: 2;
    position: relative;

    &__wrapper {
      @include screen-only-large() {
        padding: 148px 0 148px 0;
      }

      @include screen-only-medium() {
        padding: 72px 0 72px 0;
      }

      @include screen-only-small {
        padding: $spacing-48 0 $spacing-48 0;
      }
    }

    &__image {
      border-radius: 500px;
    }

    &__image-div {
      @include screen-only-small() {
        padding-top: $spacing-24;
      }
    }

    &__button {
      flex-direction: column !important;
    }
  }

  &__wrapper {
    @include screen-only-small() {
      text-align: left;
    }
  }

  &__section {
    position: relative;
    overflow-y: clip;
    background-color: $color-grey-3200;

    &__svg {
      position: absolute;
      left: 43%;
      transform: translateX(-50%);
      width: 100%;
      height: 100%;
      top: 8vh;

      @include screen-only-small {
        top: 2vh;
      }
    }
  }
}
</style>
